import React from 'react';
import { connect } from 'react-redux';
import Notification from '@zg-rentals/multibrand-ui/lib/Notification';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

interface IErrorBoundaryProps {
  user?: Record<string, unknown>;
}

class ErrorBoundary extends React.Component<React.PropsWithChildren<IErrorBoundaryProps>> {
  state = {
    hasError: false,
  };

  componentDidCatch(err, info) {
    const { user } = this.props;

    // Display fallback UI
    this.setState({ hasError: true });
    RpErrorBoundary.logError(err, info, { user });
  }

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <Notification type="error" onClose={() => {}}>
          Sorry, something went wrong. Please try again in a few minutes.
        </Notification>
      );
    }

    return this.props.children;
  }
}

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps)(ErrorBoundary);
